/* projects/common-module/src/lib/app-dialog/settings-dialog/select-timezone/select-timezone.component.scss */
mat-form-field {
  width: 100%;
}
/*# sourceMappingURL=select-timezone.component.css.map */
